import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaOperacion } from '../_operacion.js';

/**
 * La vista a la que llega el operario y el jefe de operarios al entrar, que es a donde
 * apunta `rutaInicialDe('operario')`.
 *
 * Existe porque `_operacion` es una ruta SIN `path`: envuelve a sus hijos con el guardián
 * pero no crea ninguna dirección visitable. Sin este archivo, `/operacion` no es una ruta
 * y el operario que acaba de ingresar bien aterriza en `notFound`.
 *
 * El componente llega a pedido. Las pantallas de la noche las cuelgan las fases 2 y 8
 * como hermanas de esta, y esta pasa a ser su menú.
 */
export const rutaInicioOperacion = createRoute({
  getParentRoute: () => rutaOperacion,
  path: '/operacion',
  component: lazyRouteComponent(() => import('./pantalla-inicio.js'), 'InicioOperacion'),
});
